import { useMemo } from 'react'
import { FlagxsColumnDef } from '../../../../containers/BulkSheetView/gridOptions/extension'
import {
  PATH_COLUMN_GROUP_DEF,
  useAssignmentColumnGroupDef,
  useDefaultColumnGroupDef,
  useDisplayNameColumnDef,
  useInformationColumnGroupDef,
  useTermColumnGroupDef,
} from './column'
import { WbsItemSelectColumnOptionType } from '../../../../hooks/useWbsItemSelectColumnOptions'

export type Props = {
  projectUuid: string
  context: WbsItemSelectColumnOptionType | undefined
}

export const useColumnDefs = ({
  context,
  projectUuid,
}: Props): FlagxsColumnDef[] => {
  const defaultColumnGroupDef = useDefaultColumnGroupDef()
  const informationColumnGroupDef = useInformationColumnGroupDef(
    projectUuid,
    context
  )
  const nameColumnGroupDef = useDisplayNameColumnDef()
  const assignmentColumnGroupDef = useAssignmentColumnGroupDef({
    context,
  })
  const termColumnGroupDef = useTermColumnGroupDef()

  const columnDefs = useMemo(
    () => [
      defaultColumnGroupDef,
      informationColumnGroupDef,
      PATH_COLUMN_GROUP_DEF,
      nameColumnGroupDef,
      assignmentColumnGroupDef,
      termColumnGroupDef,
    ],
    [
      defaultColumnGroupDef,
      informationColumnGroupDef,
      nameColumnGroupDef,
      assignmentColumnGroupDef,
      termColumnGroupDef,
    ]
  )
  return columnDefs
}
